import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Card, CardContent } from "@groot/ui/card";
import { Mail, Clock, Play, Zap, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS: Record<string, LucideIcon> = {
  email_received: Mail,
  scheduled: Clock,
  manual: Play,
};

export function TriggerNode({ data, selected }: NodeProps) {
  const Icon = ICONS[data.triggerType as string] || Zap;

  return (
    <div className={cn("w-64", selected && "ring-2 ring-primary rounded-lg")}>
      <Card>
        <CardContent className="p-4 flex items-center gap-3">
          <div className="size-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
            <Icon size={20} />
          </div>
          <div>
            <div className="font-medium text-sm">Trigger</div>
            <div className="text-xs text-muted-foreground capitalize">
              {(data.label as string) || "Configure Trigger"}
            </div>
          </div>
        </CardContent>
      </Card>
      <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-primary" />
    </div>
  );
}
